import { ReducerEntityPrefixTypes, ReducerNamespaceTypes, SortingDirection } from "enums";
import { type FiltersState, createFiltersSlice } from "features/Application/slices/createFiltersSlice";
import { type ScormFiltersEnum } from "../../types/models";
import type { PayloadAction } from "@reduxjs/toolkit";

export const initialState: FiltersState<ScormFiltersEnum> = {
  filterOptions: {},
  appliedFilter: {},
  isLoading: false,
  pagination: 1,
  sortingColumnName: undefined,
  sortingDirection: undefined,
};

const filtersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.Scorm,
    name: "OverviewFilters",
  },
  initialState,
  reducers: {
    setPlainSortingDirection: (state, action: PayloadAction<string>) => {
      state.sortingDirection =
        action.payload.toLowerCase() === "desc" ? SortingDirection.Descending : SortingDirection.Ascending;
    },
  },
});

export const {
  setAppliedFilter,
  resetAppliedFilter,
  setIsLoading,
  setError,
  setFilterOptions,
  resetSearch,
  setSearch,
  setPagination,
  resetPagination,
  setSortingColumnName,
  resetSortingColumnName,
  setSortingDirection,
  setPlainSortingDirection,
  resetSortingDirection,
  resetFilter,
} = filtersSlice.actions;

export default filtersSlice.reducer;
